import React from 'react';
import { ReactComponent as Cart } from '../../icons/cart.svg';
import { MoneyFormat } from '../../components/elements';
import { useCandyCartContext } from '../../contexts/CandyCartContext';
import { usePopupContext } from '../../contexts/Settings';
import { CandyCartSettings } from '../../types';

type IconProps = {
  customIcon: string | undefined;
};

const CartIcon: React.FC<IconProps> = ({ customIcon }) => {
  if (customIcon) {
    return (
      <img src={customIcon} alt="Cart Icon" width="25px" height="25px"></img>
    );
  }
  return <Cart />;
};

const CandyCartHeader: React.FC = () => {
  const { cartTotal } = useCandyCartContext();
  const settings = usePopupContext().settings as CandyCartSettings;

  return (
    <>
      <div className="Icon-Name flex items-center">
        <div className="Product-Icon bg-white rounded-full p-15">
          <CartIcon customIcon={settings.custom_cart_icon} />
        </div>
        <div className="Product-Name flex-1 font-semibold mx-15">
          {settings?.text.headline}
        </div>
      </div>
      <div className="Offer-Price text-grey-1 font-bold text-md">
        <MoneyFormat amount={cartTotal ?? 0} />
      </div>
    </>
  );
};

export default CandyCartHeader;
